<script setup>
import { computed, onMounted, watch } from "vue";
import { useStore } from "vuex";
import { useLocale } from "vuetify";
import { useLoading } from "vue-loading-overlay";

const store = useStore();
const { current } = useLocale();
const loadingPlugin = useLoading();

let loader = null;

const loading = computed(() => store.state.loader.loading);
watch(loading, (newState) => {
  if (newState) {
    loader = loadingPlugin.show({
      // Optional parameters
      container: null,
      // color: this.$vuetify.theme.themes.light.primary,
      color: "#2196f3", // Temporario
      loader: "spinner",
      height: 50,
      // backgroundColor: "#333",
      backgroundColor: "#CCC",
      opacity: 0.8,
      canCancel: false,
    });
  } else {
    if (loader !== null) loader.hide();
  }
});

onMounted(() => {
  let languageCookie = store.getters["configs/chosenLocale"];
  if (languageCookie) {
    current.value = languageCookie;
  }
});
</script>

<template>
  <router-view />
</template>
